import { IconPhotoPlus as TablerIconPhotoPlus } from '@tabler/icons-react';

import { createOutlineIcon } from '@/components/icon/createOutlineIcon';

export const IconPhotoPlus = /*#__PURE__*/ createOutlineIcon(TablerIconPhotoPlus, 'IconPhotoPlus');
